import { Text } from '@chakra-ui/react';
import cn from 'classnames';
import React from 'react';

import styles from './colour-type-item.module.scss';

export const ColourTypeItem: React.FC<{
  colourType: any;
  selectFilter: (filterId: number) => void;
}> = ({ colourType, selectFilter }) => {
  return (
    <div
      onClick={() => selectFilter(colourType.id)}
      className={cn(styles.colourTypeItem, {
        [styles.colourTypeItemSelected as string]: colourType.isSelected,
        [styles.colourTypeItemDisabled as string]: colourType.isDisabled,
      })}
    >
      <div
        className={cn(
          styles.colourCircle,
          styles[`colourCircle-${colourType.id}`],
          {
            [styles.colourCircleWithBorder as string]:
              colourType.name === 'White',
          },
        )}
      ></div>
      <Text className={styles.colourText}>{colourType.name}</Text>
    </div>
  );
};
